module.exports = __webpack_public_path__ + "static/media/MountainRetreatEXTA0037_design_clean_v002.f6137ec6.png";